var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeneralSafetyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0H26C33.732 0 40 6.26801 40 14V26C40 33.732 33.732 40 26 40H14C6.26801 40 0 33.732 0 26V14Z",
    fill: "#E7000B",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8097_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6666 20.8333C26.6666 25 23.7499 27.0833 20.2833 28.2916C20.1017 28.3532 19.9045 28.3502 19.7249 28.2833C16.2499 27.0833 13.3333 25 13.3333 20.8333V15C13.3333 14.779 13.421 14.567 13.5773 14.4107C13.7336 14.2544 13.9456 14.1666 14.1666 14.1666C15.8333 14.1666 17.9166 13.1666 19.3666 11.9C19.5431 11.7491 19.7677 11.6663 19.9999 11.6663C20.2321 11.6663 20.4567 11.7491 20.6333 11.9C22.0916 13.175 24.1666 14.1666 25.8333 14.1666C26.0543 14.1666 26.2662 14.2544 26.4225 14.4107C26.5788 14.567 26.6666 14.779 26.6666 15V20.8333Z",
    stroke: "#E7000B",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8097_37"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralSafetyIcon);
export default __webpack_public_path__ + "static/media/general_safety_icon.983b93b477641db94611abc3eeec1fe5.svg";
export { ForwardRef as ReactComponent };